<template >
  <div id="Show-News-Panel">
    <kt-row>
      <kt-col lg="12" md="12" xs="12">
        <h3>{{query.subject}}</h3>
        <hr />
      </kt-col>
    </kt-row>
    <kt-row>
      <kt-col lg="6" md="6" xs="12">{{query.created_at}}</kt-col>
    </kt-row>
    <kt-row>
      <kt-col lg="12" md="12" xs="12">{{query.newscontent}}</kt-col>
    </kt-row>
  </div>
</template>
<script>
export default {
  props: {
    query: {
      default() {
        return {};
      },
      type: Object,
    },
  },
};
</script>